export const AppRoutes = {
  // Login
  login: "/login",
  logout: "/logout",
  recover: "/recover",
  recoverComplete: "/recover-complete",
  resetPassword: "/reset-password",
  resetPasswordComplete: "/reset-password-complete",
  register: "/register",
  registerComplete: "/register-complete",

  // Home
  home: "/",

  // RSO Management
  duringContractList: "/rso/during-contract",
  canceledContractList: "/rso/canceled-contract",
  trialRsoList: "/rso/trial",
  trialCancelledList: "/rso/trial-cancelled",
  rsoCreate: "/rso/create",
  rsoDetail: "/rso/:id/detail",
  rsoEdit: "/rso/:id/edit",
  rsoUserCreate: "/rso/:id/user/create",
  rsoUserEdit: "/rso/:id/user/:userId/edit",

  // Company Management
  companyDuringContractList: "/company/during-contract",
  companyCanceledContractList: "/company/canceled-contract",
  companyTrialList: "/company/trial",
  companyTrialCancelledList: "/company/trial-cancelled",
  companyCreate: "/company/create",
  companyDetail: "/company/:id/detail",
  companyEdit: "/company/:id/edit",
  companyUserCreate: "/company/:id/user/create",
  companyUserEdit: "/company/:id/user/:userId/edit",

  // Admin user
  adminUser: "/admin-user",
  adminUserCreate: "/admin-user/create",
  adminUserDetail: "/admin-user/:id",
  adminUserEdit: "/admin-user/:id/edit",

  // information
  information: "/information",
  informationCreate: "/information/create",
  informationEdit: "/information/:id/edit",

  // Convert
  convert: "/convert",
  convertHistory: "/convert/history",
  convertDetail: "/convert/:id",

  // Master data
  masterData: "/master-data",
  masterDataDetail: "/master-data/:type",

  // System setting
  emailSetting: "/email-setting",
  maintenanceSetting: "/maintenance-setting",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Chat
  chat: "/chat",
  chatDetail: "/chat/:id",

  // Learning content
  learningContent: "/learning-content",
  industryDetail: "/learning-content/industry/:id",
  industryEdit: "/learning-content/industry/:id/edit",
  industryCreate: "/learning-content/industry/create",
  learningContentSubjectCreate: "/learning-content/industry/:id/subject/create",
  learningContentSubjectDetail: "/learning-content/industry/:id/subject/:subjectId",
  learningContentSubjectEdit: "/learning-content/industry/:id/subject/:subjectId/edit",
  learningContentWordDetail: "/learning-content/industry/:id/word-detail",
  learningContentWordEdit: "/learning-content/industry/:id/word-edit",
  learningContentExamCreate: "/learning-content/industry/:id/exam/create",
  learningContentExamEdit: "/learning-content/industry/:id/exam/:examId/edit",
  learningContentMockExamCreate: "/learning-content/industry/:id/mock-exam/create",
  learningContentMockExamDetail: "/learning-content/industry/:id/mock-exam/:mockExamId",
  learningContentMockExamEdit: "/learning-content/industry/:id/mock-exam/:mockExamId/edit",
};

export const RsoManagementRoutes = [
  AppRoutes.duringContractList,
  AppRoutes.trialRsoList,
  AppRoutes.canceledContractList,
  AppRoutes.trialCancelledList,
  AppRoutes.rsoCreate,
  AppRoutes.rsoDetail,
  AppRoutes.rsoEdit,
  AppRoutes.rsoUserCreate,
  AppRoutes.rsoUserEdit,
];

export const CompanyManagementRoutes = [
  AppRoutes.companyDuringContractList,
  AppRoutes.companyTrialList,
  AppRoutes.companyCanceledContractList,
  AppRoutes.companyTrialCancelledList,
  AppRoutes.companyCreate,
  AppRoutes.companyDetail,
  AppRoutes.companyEdit,
  AppRoutes.companyUserCreate,
  AppRoutes.companyUserEdit,
];

export const AdminUserRoutes = [AppRoutes.adminUser, AppRoutes.adminUserCreate, AppRoutes.adminUserDetail, AppRoutes.adminUserEdit];

export const InformationRoutes = [AppRoutes.information, AppRoutes.informationCreate, AppRoutes.informationEdit];

export const ConvertRoutes = [AppRoutes.convert, AppRoutes.convertHistory, AppRoutes.convertDetail];

export const MasterDataRoutes = [AppRoutes.masterData, AppRoutes.masterDataDetail];

export const SystemSettingRoutes = [AppRoutes.emailSetting, AppRoutes.maintenanceSetting];

export const ChatRoutes = [AppRoutes.chat, AppRoutes.chatDetail];

export const LoginRoutes = [AppRoutes.login, AppRoutes.recover, AppRoutes.resetPassword, AppRoutes.register];

export const LearningContentRoutes = [
  AppRoutes.learningContent,
  AppRoutes.industryDetail,
  AppRoutes.industryEdit,
  AppRoutes.industryCreate,
  AppRoutes.learningContentSubjectCreate,
  AppRoutes.learningContentSubjectDetail,
  AppRoutes.learningContentSubjectEdit,
  AppRoutes.learningContentWordDetail,
  AppRoutes.learningContentWordEdit,
  AppRoutes.learningContentExamCreate,
  AppRoutes.learningContentExamEdit,
  AppRoutes.learningContentMockExamCreate,
  AppRoutes.learningContentMockExamDetail,
  AppRoutes.learningContentMockExamEdit,
];

export const AdminRoutes = [
  AppRoutes.home,
  LearningContentRoutes,
  RsoManagementRoutes,
  CompanyManagementRoutes,
  AdminUserRoutes,
  InformationRoutes,
  SystemSettingRoutes,
  ChatRoutes,
  ConvertRoutes,
  MasterDataRoutes,
].flat();
